module.exports = __webpack_public_path__ + "img/close.83f89264.svg";